import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { IsCTSEmployeeActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class IsCTSEmployeeEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getIsCTSEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IsCTSEmployeeActions.getIsCTSEmployee),
      switchMap((action) =>
        this.onboardingProductsService.getIsCTSEmployee(action).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
          IsCTSEmployeeActions.getIsCTSEmployeeSucess({ response: res })
          ),
          catchError((error) =>
            of(
              IsCTSEmployeeActions.getIsCTSEmployeeError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
